import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NbDialogService, NbIconComponent } from '@nebular/theme';
import { OfbizForm } from '@urbannex/ofbiz-forms';
import { LookUpDialogService } from '../lookup-dialog-container/look-up-dialog.service';
import { LookupDialogContainerComponent } from '../lookup-dialog-container/lookup-dialog-container.component';
import { ActionState, ComponentConfig, ComponentState } from '../shared/model';
import { getEnumKeyByEnumValue, UbsComponentStoreService } from '../ubs-component-store.service';
import { ViewContainersService } from '../shared/services/view-containers.service';
import { Observable, take } from 'rxjs';

@Component({
  selector: 'ubs-add-container',
  templateUrl: './add-container.component.html',
  styleUrls: ['./add-container.component.scss']
})
export class AddContainerComponent implements OnInit,OnChanges {
  @Input() activeLevel:number;
  @Input() addForms:OfbizForm[];
  @Input() action:string;
  @Input()
    set state(state:Observable<ComponentState>){
      state.pipe(take(1)).subscribe(componentState => {
        this.componentConfig = componentState.componentConfig;
        this.addForm = this.componentConfig.addForm;
        this.clearForm();
        this.target = this.addForm.getTarget("add");
        this.options.formName = this.addForm.formName;
        this.options.entityName = this.addForm.entityName;
        this.options.formLocation = this.addForm.formLocation;
        if(this.addForm.renderComponent){
          this.hasCustomView = true;
          this.customView = this.addForm.renderComponent;
         }
      })
    }
  componentConfig:ComponentConfig
  addForm:OfbizForm;
  options:any = {};
  title:string;
  //state:any;
  target:string;
  altTarget:string;
  hasCustomView:boolean = false;
  customView:string;
  viewMode:any;

  findOpen:boolean = true;

  @ViewChild("chevron", {read: ElementRef}) chevron: NbIconComponent;
  @ViewChild("container", {read: ElementRef}) container: ElementRef;

  @Output() popoverClosed = new EventEmitter<string>();


  constructor(
    private componentStore:UbsComponentStoreService,
    private dialogService: NbDialogService,
    private lookUpDialogService:LookUpDialogService,
    private viewContainerService:ViewContainersService) { 
      this.componentStore.activeLevel$.subscribe(data => {
        this.setTitleFormActiveLevel(data);
      })
    }

  ngOnInit(): void {
    /* this.componentStore.vm$.subscribe(data => {
      this.state = data;
    }); */
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    /* if(changes["addForms"]){
      console.log({TrackAddForms:"AddContainerComponent",value:this.addForms,activeLevel:this.activeLevel});
    } */
    if(changes["addForms"] && this.activeLevel != undefined){
      console.log({TrackAddForms:"AddContainerComponent",value:this.addForms,activeLevel:this.activeLevel});
      /* this.addForm = this.addForms[this.activeLevel-1];
      console.log({addForm:this.addForm});
      this.target = this.addForm.getTarget("add");
      this.options.formName = this.addForm.formName;
      this.options.entityName = this.addForm.entityName;
      this.options.formLocation = this.addForm.formLocation;
      if(this.addForm.renderComponent){
        this.hasCustomView = true;
        this.customView = this.addForm.renderComponent;
       } */
      
    }
    if(changes["activeLevel"]){
      console.log({TrackActiveLevel:"AddContainerComponent",value:this.activeLevel});
    }
  }

  setTitleFormActiveLevel(level:number):void{
    this.componentStore.componentConfig$.subscribe(data => console.log({componentConfig:data}));
    this.componentStore.breadCrumbs$.subscribe(data => {
      let selectedBreadCrumb = data.find(element => element.level == level);
      if(selectedBreadCrumb != undefined){
        this.title = selectedBreadCrumb.addFormText;
        console.log({Title:this.title});
      }
    })
  }

  resetAction(event){
    console.log({resetActionEvent:event});
    console.log({activeLevel:this.activeLevel});
    console.log({selectedValue:this.state["selectedValue"]});
    this.componentStore.updateAction(event);
    //this.componentStore.updateActiveLevel(this.activeLevel);
    //console.log({ActionEvent:getEnumKeyByEnumValue(ActionState,event)});
  }

  openDialogContainer(data):void{
    console.log({TrackDialog:{component:"AddContainerComponent",data:data}});
    //let componentConfig:ComponentConfig = this.state.componentConfig;
    this.dialogService.open(LookupDialogContainerComponent, {
      context:{
        componentConfig:this.componentConfig,
        data:data
      },
      dialogClass:'modal-full',
    })
  }

  toggleIcon(){
    console.log(this.chevron);
    if(this.findOpen){
      this.findOpen = false;
      this.container.nativeElement.style.display = "none";
    }else{
      this.findOpen = true;
      this.container.nativeElement.style.display = "block";
    }
  }
  togglePopover(){
    this.popoverClosed.emit();
  }

  clearForm(){
    this.addForm.fields.forEach(field => {
      field.value = "";
    })
  }

  /* openDialogContainer(data){
   console.log({TrackLookupDialog:"AddContainerComponent"}) 
  } */


}
